module.exports = __webpack_public_path__ + "static/img/guide1.6d48c1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guide1.png
// module id = 6Gti
// module chunks = 0